const parserRef = {
  current: null as DOMParser | null,
};

/**
 * Safely unescape an html-escaped string.
 * @param input
 */
export default function htmlUnescape(input: string): string {
  if (!parserRef.current) {
    parserRef.current = new DOMParser();
  }

  if (!input) {
    return '';
  }

  const doc = parserRef.current.parseFromString(input, 'text/html');

  return doc.documentElement.textContent ?? '';
}
